$(document).ready(function() {
    /*
    podcast player
     */
    var podcast_array = [];
    var sound;

    var podcast_url = "/json/podcasts/";
    var podcast_localstorage_key = "aac_podcast";
    var podcast_ttl = 900000; // 15 min cache

    $.urlParam = function(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.href);
        if (results == null) {
            return 0;
        }
        return results[1] || 0;
    };

    var utils = {
        formatTime: function(secs) {
            var minutes = Math.floor(secs / 60) || 0;
            var seconds = (secs - minutes * 60) || 0;
            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        },
        updateTimeTracker: function() {
            var self = this;
            var seek = sound.seek() || 0;
            var currentTime = utils.formatTime(Math.round(seek));

            $('.podcast-timer').text(currentTime);
            $('span.pause').data('label', currentTime);

            if (self.playing()) {
                requestAnimationFrame(utils.updateTimeTracker.bind(self));
                podcast_progress_bar.slider("value", (((seek / self.duration()) * 1000) || 0));
            }
        }
    };

    var setPlayer = function(title, desciption, mp3_source) {
        var autoplay = false;

        if ($.urlParam('autoplay') == 1) {
            autoplay = true;
            $('.podcast-sound').addClass('playing')
        }

        $('.podcast_title').text(title);
        $('.podcast_desc p').html(desciption);
        sound = new Howl({
            src: mp3_source,
            autoplay: autoplay,
            html5: true,
            preload: false,
            onplay: function() {
                audioPlayed = true;
                var time = Math.round(sound.duration());
                $('.podcast-duration').html(utils.formatTime(time));
                // Start upating the progress of the track.
                requestAnimationFrame(utils.updateTimeTracker.bind(this));
                $('span.play').addClass('hidden');
                $('span.pause').removeClass('hidden');
                $('.podcast_desc p').removeClass('ellipsis');
                $('.podcast_desc').addClass('marquee');
            },
            onpause: function() {
                $('span.play').removeClass('hidden');
                $('span.pause').addClass('hidden');
                $('.podcast_desc p').addClass('ellipsis');
                $('.podcast_desc').removeClass('marquee');
            },
            onend: function() {
                $('span.play').removeClass('hidden');
                $('span.pause').addClass('hidden');
                $('.podcast-sound').toggleClass('playing');
                $('.podcast_desc p').addClass('ellipsis');
                $('.podcast_desc').removeClass('marquee');

                var category = "Podcast";
                var action = "Finished";
                var label = mp3_source;

                if (typeof ga === 'function') {
                    ga('send', 'event', category, action, label);
                }
                if (typeof gtag === 'function') {
                    gtag("event", category, {
                        action: action,
                        source: label,
                      });
                }
            }
        });


    };

    // var podcastUpdater = {
    //     save: function(data) {
    //         $.jStorage.set(podcast_localstorage_key, data);
    //         $.jStorage.setTTL(podcast_localstorage_key, podcast_ttl);
    //     },
    //     get: function() {
    //         return $.jStorage.get(podcast_localstorage_key, 0);
    //     },
    //     update: function(json) {
    //         $.each(json, function(key, value) {
    //             if (key == "podcasts") {
    //                 $.each(value, function(index, podcast) {
    //                     podcast_array.push(podcast);
    //                 });
    //             }
    //         });
    //         if ($('#podcast_page_url').length > 0) {
    //             page_url = $('#podcast_page_url').text();
    //             page_title = $('#podcast_page_title').text();
    //             page_desc = $('#podcast_page_desc').text();
    //             $('span.play').attr('data-label', page_url);
    //             $('span.pause').attr('data-label', page_url);
    //             setPlayer(page_title, page_desc, page_url);
    //         } else {
    //             $('span.play').attr('data-label', podcast_array[0].url);
    //             $('span.pause').attr('data-label', podcast_array[0].url);
    //             setPlayer(podcast_array[0].title, podcast_array[0].description, podcast_array[0].url);
    //         }
    //     }
    // };
    // var podcast_json = podcastUpdater.get();
    // if (podcast_json === 0) {
    //     $.getJSON(podcast_url, function(podcast_json) {
    //         if (parseInt(podcast_json.status) === 200) {
    //             podcastUpdater.save(podcast_json);
    //             podcastUpdater.update(podcast_json);
    //         }
    //     });
    // } else {
    //     podcastUpdater.update(podcast_json);
    // }
    if ($('#podcast_page_url').length > 0) {
        page_url = $('#podcast_page_url').text();
        page_title = $('#podcast_page_title').text();
        page_desc = $('#podcast_page_desc').text();
        $('span.play').attr('data-label', page_url);
        $('span.pause').attr('data-label', page_url);
        setPlayer(page_title, page_desc, page_url);
    }

    // Play/pause button
    $('.podcast-sound').on('click', function() {
        $('.podcast-sound').toggleClass('playing');
        if ($(this).hasClass('playing')) {
            sound.play();
        } else {
            sound.pause();
        }
    });

    var wasPlaying = false;
    var podcast_progress_bar = $("div.podcast-progress-slider");
    podcast_progress_bar.slider({
        min: 0,
        max: 1000,
        create: function create(event, ui) {
            $(this).slider('option', 'range', 'min');
            $(this).slider('option', 'step', 1);
            $(this).slider('option', 'value', 0);
        },
        slide: function(event, ui) {
            if ($('.podcast-sound').hasClass('playing')) {
                $('.podcast-sound').removeClass('playing')
                sound.pause();
                wasPlaying = true;
            }
            var percentage = ui.value / 1000;
            sound.seek(percentage * sound.duration());
            $('.podcast-timer').text(utils.formatTime(Math.round(percentage * sound.duration())));
        },
        stop: function(event, ui) {
            if (wasPlaying) {
                $('.podcast-sound').addClass('playing')
                sound.play();
                wasPlaying = false;
            }
        }
    });


    if ($("div.podcast-volume-slider").length > 0) {

        var set_volume_icon = function(value) {
            if (value == 0) {
                $(".podcast-volume span svg").addClass("hidden").removeClass("active");
                $(".podcast-volume span svg.vol-mute").removeClass("hidden").addClass("active");
            } else if (value > 0 && value <= 25) {
                $(".podcast-volume span svg").addClass("hidden").removeClass("active");
                $(".podcast-volume span svg.vol-lowest").removeClass("hidden").addClass("active");
            } else if (value > 25 && value <= 50) {
                $(".podcast-volume span svg").addClass("hidden").removeClass("active");
                $(".podcast-volume span svg.vol-low").removeClass("hidden").addClass("active");
            } else if (value > 50 && value <= 75) {
                $(".podcast-volume span svg").addClass("hidden").removeClass("active");
                $(".podcast-volume span svg.vol-medium").removeClass("hidden").addClass("active");
            } else {
                $(".podcast-volume span svg").addClass("hidden").removeClass("active");
                $(".podcast-volume span svg.vol-high").removeClass("hidden").addClass("active");
            }
        };

        var podcast_volume_bar = $("div.podcast-volume-slider");
        podcast_volume_bar.slider({
            min: 0,
            max: 100,
            orientation: "vertical",
            create: function create(event, ui) {
                $(this).slider('option', 'range', 'min');
                $(this).slider('option', 'step', 1);
                $(this).slider('option', 'value', 100);
            },
            slide: function(event, ui) {
                $(".podcast-volume >div").removeClass("hidden").addClass("flex");
                sound.volume(ui.value / 100);
                set_volume_icon(ui.value);
            },
            stop: function(event, ui) {
                $(".podcast-volume >div").addClass("hidden").removeClass("flex");
            }
        });

        var previous_volume = 100;

        $("div.podcast-volume span").on('click', function(e) {
            if ($(".podcast-volume span svg.vol-mute").hasClass("active")) {
                podcast_volume_bar.slider('option', 'value', previous_volume);
                sound.volume(previous_volume / 100);
                set_volume_icon(previous_volume);
            } else {
                previous_volume = podcast_volume_bar.slider('value');
                podcast_volume_bar.slider('option', 'value', 0);
                sound.volume(0);
                set_volume_icon(0);
            }
        });
    }
});